/** @jsx jsx */
/** @jsxFrag null */
import kebabCase from 'lodash/kebabCase';
import {jsx} from 'panel';

import {AutoDocEl} from '../components/auto-doc';

export function AutoDoc({componentName}, content) {
  return (
    <div sel='.auto-doc-wrapper'>
      {content}
      <AutoDocEl attrs={{component: componentName}} />
    </div>
  );
}

export function Section({title}, content) {
  const id = kebabCase(title);
  return (
    <section class={{[id]: true, 'mp-panel': true}} key={id} attrs={{id, 'data-label': title}}>
      <div sel='.mp-panel-section'>
        <h1>{title}</h1>
      </div>
      {content}
    </section>
  );
}

export function SubSection({title = ``, autoDoc = false} = {}, content) {
  const id = kebabCase(title);
  return (
    <div
      class={{[`${id}-subsection`]: true, 'mp-panel-section': true, 'sub-section': true}}
      key={id}
      attrs={{id, 'data-label': title}}
    >
      {title && <h2>{title}</h2>}
      {autoDoc ? <AutoDoc componentName={title}>{content}</AutoDoc> : content}
    </div>
  );
}
